<template>
	<el-container>
		<el-scrollbar>
			<el-header class="header-top" style="height: 50px;"><s-header-top></s-header-top></el-header>
			<el-header class="header"><s-header></s-header></el-header>
			<el-main>
				<div class="content">
					<el-row type="flex" justify="space-between">
						<el-col :span="12">
							<el-breadcrumb separator-class="el-icon-arrow-right">
								<span style="float: left;">当前位置：</span>
								<el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
								<el-breadcrumb-item :to="{ path: '/activity' }">双创活动</el-breadcrumb-item>
							</el-breadcrumb>
						</el-col>
						<el-col :span="6">
							<el-input placeholder="输入关键字" v-model="title" @change="getActivityList"><el-button slot="append" icon="el-icon-search"></el-button></el-input>
						</el-col>
					</el-row>

					<div class="page table">
						<div class="lists">
							<el-row class="item" v-for="(item, index) in activityList" :key="index">
								<el-col :span="5" class="itemImage">
									<el-image style="width: 100%; height: 100%" :src="item.actImg ? imgPath(item.actImg) : require('../../static/pro.jpg')" fit="fill"></el-image>
									<template v-if="item.actType=='2'">
										<div class="state">活动回顾</div>
									</template>
									<template v-else>
										<div class="state_close" v-if="item.actEnrollendtime < currentDate">已结束</div>
										<div class="state" v-else>火热报名中</div>
									</template>
								</el-col>
								<el-col :span="15" class="itemList">
									<div class="list" @click="goDetail(item)">
										<el-row class="name">
											<el-col :span="24">{{ item.actTitle }}</el-col>
										</el-row>
										<el-row class="label">
											<el-col :span="24">
												<span>{{ item.actBrief }}</span>
											</el-col>
										</el-row>
										<el-row class="label">
											<el-col :span="24">
												<span>活动时间：{{ item.actBegintime }}</span>
											</el-col>
										</el-row>
										<el-row class="label">
											<el-col :span="24">
												<span>活动地点：{{ item.actAddress }}</span>
											</el-col>
										</el-row>
										<el-row class="label">
											<el-col :span="24">
												<span>报名截止时间：{{ item.actEnrollendtime }}</span>
											</el-col>
										</el-row>
									</div>
								</el-col>
								<el-col :span="4" class="itemEnter" v-if="item.actType!='2'">
									<el-row type="flex" justify="center" align="middle">
										<div class="pay" v-if="item.actPrice == '' || item.actPrice == '0' || item.actPrice == '0.00'">免费</div>
										<div class="pay" v-else>￥{{ item.actPrice }}</div>
									</el-row>
									<el-row type="flex" justify="center"><!-- <div class="follow">0人已关注</div> --></el-row>
									<el-row type="flex" justify="center">
										<div class="enter_close" v-if="item.actEnrollendtime < currentDate">报名结束</div>
										<div class="enter" v-else @click="openDialog(item)">我要报名</div>
									</el-row>
								</el-col>
							</el-row>
						</div>
						<pagination v-show="pageTotal>0" :total="pageTotal" :page.sync="currentPage" :limit.sync="pageSize" @pagination="getActivityList" />
					</div>

					<!-- 活动报名dialog -->
					<el-dialog title="活动报名" :visible.sync="dialogVisible">
						<!-- 二维码dialog -->
						<el-dialog title="扫码支付" :visible.sync="payDialogVisible" width="30%" append-to-body>
							<span style="text-align: center;display: block;"><img style="width: 340px;height: 340px;" :src="QRcode" /></span>
							<span style="text-align: center;display: block;margin-top: 10px;">扫码支付{{ money }}元</span>
							<span slot="footer" class="dialog-footer">
								<el-button @click="payDialogVisible = false">取 消</el-button>
								<el-button @click="toOrder()">已支付</el-button>
							</span>
						</el-dialog>
						<!-- 输入金额表单 -->
						<el-form :model="form" :rules="rules" ref="ruleForm" label-width="100px">
							<el-form-item label="姓名" prop="name"><el-input v-model="form.name" autocomplete="off"></el-input></el-form-item>
							<el-form-item label="电话" prop="telephone"><el-input v-model="form.telephone" autocomplete="off"></el-input></el-form-item>
						</el-form>
						<div slot="footer" class="dialog-footer">
							<el-button @click="dialogVisible = false">取 消</el-button>
							<el-button type="primary" @click="signActivity()">确 定</el-button>
						</div>
					</el-dialog>
				</div>
			</el-main>
			<el-footer class="footer"><s-footer></s-footer></el-footer>
			<el-footer class="copy-right"><s-copyRight></s-copyRight></el-footer>
		</el-scrollbar>
	</el-container>
</template>

<script>
import sHeaderTop from '@/components/header_top';
import sHeader from '@/components/header';
import sFooter from '@/components/footer';
import sCopyRight from '@/components/copy-right';
import Pagination from '@/components/Pagination';
import { activityList, signActivity } from '@/api';
export default {
	name: 'campaign',
	components: {
		sHeaderTop,
		sHeader,
		sFooter,
		sCopyRight,
		Pagination
	},
	data() {
		var validateTel = (rule, value, callback) => {
			if (!value) {
				return callback(new Error('手机号不能为空'));
			} else if (!/^1(3|4|5|6|7|8)\d{9}$/.test(value)) {
				return callback(new Error('请输入正确的手机号'));
			} else {
				callback();
			}
		};
		const currentDate = this.getDate({
			format: true
		});
		return {
			dialogVisible: false,
			currentDate: currentDate,
			title: '',
			classify: '',
			// 当前页数
			currentPage: 1,
			// 每页默认显示条数
			pageSize: 10,
			// 总条数
			pageTotal: 0,
			activityList: [],
			form: {
				activityID: '',
				name: '',
				telephone: '',
				type:'PC'
			},
			rules: {
				name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
				telephone: [{ required: true, validator: validateTel, trigger: 'blur' }]
			},
			item: null, //当前选择要报名的活动
			payDialogVisible: false, //微信二维码支付dialog
			QRcode: '', //支付二维码
			orderId: '', //支付订单号
			money: '' //支付金额 只用于显示
		};
	},
	mounted() {
		if (this.$route.query.keyWord) {
			this.title = this.$route.query.keyWord;
		}
		this.getActivityList();
	},
	methods: {
		//获取列表
		getActivityList() {
			let _this = this;
			activityList({
				pageNo: _this.currentPage,
				pageSize: _this.pageSize,
				title: _this.title
			}).then(res => {
				_this.activityList = res.data.list;
				_this.pageTotal = res.data.count;
			});
		},
		//点击我要报名，弹出报名录入信息窗口
		openDialog(item) {
			this.dialogVisible = true;
			this.item = item;
			this.form.activityID = item.id;
		},
		//报名信息提交
		signActivity() {
			let _this = this;
			_this.$refs['ruleForm'].validate(valid => {
				if (valid) {
					signActivity(_this.form).then(res => {
						if (res.code == 0) {
							if (_this.item.actPrice == '' || _this.item.actPrice == '0' || _this.item.actPrice == '0.00') {
								//免费活动
								_this.$message('报名成功');
								_this.getActivityList();
								_this.dialogVisible = false;
							} else {
								//需支付活动
								//报名信息提交成功，弹出支付窗口
								_this.payDialogVisible = true;
								_this.QRcode = _this.$imgBaseUrl + res.data.imgUrl;
								_this.orderId = res.data.orderNo;
								_this.money = _this.item.actPrice;
							}
						}
					});
				}
			});
		},
		//支付完成，跳转至订单页面
		toOrder() {
			let routeUrl = this.$router.resolve({
				path: '/activityOrderDetail', //跳转的路径
				query: {
					//路由传参时push和query搭配使用 ，作用时传递参数
					id: this.orderId
				}
			});
			window.open(routeUrl.href, '_blank');
		},
		//跳转至活动详情
		goDetail(item) {
			let routeUrl = this.$router.resolve({
				path: '/activityDetail', //跳转的路径
				query: {
					//路由传参时push和query搭配使用 ，作用时传递参数
					id: item.id
				}
			});
			window.open(routeUrl.href, '_blank');
		},
		//图片地址
		imgPath(oldPath) {
			return this.$imgBaseUrl + oldPath;
		},
		getDate(type) {
			const date = new Date();
			const seperator1 = '-';
			const seperator2 = ':';
			//以下代码依次是获取当前时间的年月日时分秒
			let year = date.getFullYear();
			let month = date.getMonth() + 1;
			let strDate = date.getDate();
			let minute = date.getMinutes();
			let hour = date.getHours();
			let second = date.getSeconds();
			//固定时间格式
			if (month >= 1 && month <= 9) {
				month = '0' + month;
			}
			if (strDate >= 0 && strDate <= 9) {
				strDate = '0' + strDate;
			}
			if (hour >= 0 && hour <= 9) {
				hour = '0' + hour;
			}
			if (minute >= 0 && minute <= 9) {
				minute = '0' + minute;
			}
			if (second >= 0 && second <= 9) {
				second = '0' + second;
			}
			let currentdate = year + seperator1 + month + seperator1 + strDate + ' ' + hour + seperator2 + minute + seperator2 + second;
			return currentdate;
		}
	}
};
</script>

<style lang="scss" scoped>
.page {
	min-height: 618px; /*若没有tabs56  height524 若有height468 */
}
.table {
	display: flex;
	flex-direction: column;
	align-items: center;
}
.lists {
	width: 100%;
}
.item {
	width: 100%;
	margin-bottom: 20px;
	padding-bottom: 20px;
	border-bottom: 1px solid #dddddd;
}
.itemImage,
.itemList,
.itemEnter {
	height: 140px;
}
/*左边活动图片*/
.itemImage {
	position: relative;
}
.state,
.state_close {
	position: absolute;
	right: 0;
	top: 0;
	width: 100px;
	height: 30px;
	line-height: 30px;
	text-align: center;
	background-color: #999999;
	color: #ffffff;
}
.state {
	background-color: #e6a23c;
}
/*中间信息*/
.list {
	height: 100%;
	margin-left: 20px;
	margin-right: 20px;
	cursor: pointer;
}
.name {
	font-size: 17px;
}
.label {
	height: 20px;
	color: rgba(153, 153, 153, 1);
	font-size: 14px;
	margin-top: 10px;
	margin-bottom: 10px;
}
.label span {
	margin-right: 20px;
}

/*右边报名入口*/
.itemEnter {
	background-color: #f8f8f8;
}
.pay {
	margin-top: 15px;
	color: #e6a23c;
	font-size: 20px;
}
.follow {
	line-height: 45px;
	color: rgba(153, 153, 153, 1);
}
.enter,
.enter_close {
	height: 36px;
	width: 120px;
	line-height: 36px;
	text-align: center;
	background-color: #999999;
	color: #ffffff;
	margin-top: 30px;
	border-radius: 4px;
}
.enter {
	background-color: #e6a23c;
	cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/activity.vue